import React from 'react';
import styled from '@emotion/styled';
import ReactMarkdown from 'react-markdown';

const Container = styled.div`
  min-height: 100vh;
  background-color: #f5f5f7;
  padding: 2rem;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background: white;
  padding: 2rem;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  flex: 1;
`;

const Title = styled.h1`
  color: #1d1d1f;
  margin-bottom: 2rem;
  font-size: 2rem;
  text-align: center;
`;

const MarkdownContainer = styled.section`
  margin-bottom: 2rem;
  h1 {
    color: #1d1d1f;
    margin-bottom:0.5rem;
    font-size: 1.5rem;
  }
  h2 {
    color: #1d1d1f;
    margin-bottom: 0.5rem;
    font-size: 1.0rem;
  }

  p {
    color: #6e6e73;
    line-height: 1.6;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
  }

  ul, ol {
    color: #6e6e73;
    line-height: 1.6;
    margin-bottom: 0.5rem;
    padding-left: 1.5rem;
    font-size: 0.9rem;
  }

  ol {
    counter-reset: item;
  }

  ol > li {
    display: block;
    margin-bottom: 0.3rem;
    position: relative;
  }

  ol > li:before {
    content: counter(item) ". ";
    counter-increment: item;
    font-weight: bold;
    position: absolute;
    left: -1.5rem;
    width: 1.5rem;
    text-align: right;
  }

  ul > li {
    margin-bottom: 0.3rem;
  }
`;

const Footer = styled.footer`
  text-align: center;
  padding: 1rem 0;
  color: #86868b;
  font-size: 0.9rem;
`;

function CleanTextAiPrivacyPolicyJa() {
  const currentYear = new Date().getFullYear();
  const markdownContent = `
 # 利用規約

本利用規約（以下、「本規約」）は、本アプリ（以下、「本サービス」）の利用条件を定めるものです。ユーザーは、本規約に従い、本サービスを利用するものとします。

## 第1条（適用）

本規約は、本サービスの利用に関わる一切の関係に適用されます。本サービスに関して、個別に規定が設けられている場合、個別規定も本規約の一部を構成するものとします。個別規定が本規約に矛盾する場合、個別規定が優先されます。

## 第2条（サービス内容の変更・終了）

本サービスは、事前通知の上で、サービス内容を変更、追加、または終了することがあります。ユーザーはこれを承諾し、内容変更や終了に関する損害について本サービスは責任を負いません。

## 第3条（禁止事項）

ユーザーは、本サービスの利用に際し、以下の行為を行ってはなりません。

1. 法令または公序良俗に反する行為
2. 犯罪行為に関連する行為
3. 本サービスの運営を妨害する行為
4. 第三者または本サービスの知的財産権、肖像権、プライバシー権、その他の権利を侵害する行為
5. 他のユーザーに関する個人情報を収集または蓄積する行為
6. 虚偽の情報を提供する行為
7. 本サービスのシステムに対する不正アクセス、リバースエンジニアリング、逆コンパイル、逆アセンブル等の解析行為
8. スパム行為や本サービスの信頼を損なう行為
9. 本サービスのネットワークやシステムに悪影響を及ぼす可能性がある行為
10. 本サービスの機能に支障をきたすおそれのあるソフトウェアまたはコードを使用、または意図的に拡散する行為
11. 本サービスまたは第三者の信用を毀損、または名誉を毀損する行為
12. 本規約または本サービスの運営ポリシーに違反する行為
13. その他、本サービスが不適切と判断する行為

## 第4条（本サービスの提供の停止等）

本サービスは、メンテナンスやシステム障害など、事前通知なく提供の一時停止または中断を行う場合があります。停止による損害について本サービスは責任を負いません。

## 第5条（保証の否認および免責事項）

1. 本サービスは、事実上または法律上の瑕疵（安全性、信頼性、正確性等）がないことを保証しません。
2. 本サービスに起因して生じた損害について、本サービスは責任を負いません。

## 第6条（知的財産権）

本サービスの内容やデザイン、プログラム等に関する著作権や商標権等の知的財産権は、本サービスまたは正当な権利を有する第三者に帰属します。ユーザーは、これらを無断で使用することはできません。

## 第7条（個人情報の取扱い）

本サービスは、ユーザーの個人情報を「プライバシーポリシー」に従い適切に取り扱います。

## 第8条（権利義務の譲渡の禁止）

ユーザーは、本サービスの利用権を第三者に譲渡、転貸または担保提供することはできません。

## 第9条（通知）

本サービスからの通知は、本サービス内での表示、またはその他適切と認められる方法で行われます。通知内容は表示後、直ちに有効とみなされます。

## 第10条（広告の表示）

本サービスは、ユーザーの利用環境に広告を表示することがあります。

## 第11条（利用規約の変更）

1. 本サービスは、本規約をユーザーの一般利益に適合すると判断した場合、または必要と認めた場合に変更することができます。
2. 本規約の変更は事前通知され、通知後に利用を継続した場合、ユーザーは変更後の規約に同意したと見なします。

## 第12条（準拠法および裁判管轄）

本規約の解釈には日本法を準拠法とし、紛争が生じた場合には、当サービスの運営者所在地を管轄する裁判所を専属的合意管轄とします。

## 第13条（附則）

本規約は、本サービス内で公表した時点から適用されます。
  `;

  return (
    <Container>
      <Content>
        <Title>利用規約</Title>
        <MarkdownContainer>
          <ReactMarkdown>{markdownContent}</ReactMarkdown>
        </MarkdownContainer>
      </Content>
      <Footer>
        <p>© {currentYear} linappworks. All rights reserved.</p>
        <p>Contact us: linappworks@gmail.com</p>
      </Footer>
    </Container>
  );
}

export default CleanTextAiPrivacyPolicyJa; 